export const site = {
  name: 'RoamMyWay',
  tagline: 'Navigate Your Next Adventure.',
  hero: {
    headline: ['Somewhere New', 'Awaits.'],
    /** The phrase rendered in RoamMyWay blue. */
    highlight: 'Awaits.',
    body: 'Give RoamMyWay a destination and a date range and get back a day-by-day itinerary — priced, sequenced and ready to book.',
    cta: { label: 'Plan My Trip', href: '#how-it-works' },
    support: 'No spreadsheets, no forty open tabs. Just tell us where, and we handle the how.',
  },
  /** Interactive globe, mounted between How-it-works and Why-Choose. */
  exploreGlobe: {
    eyebrow: 'Pick A Point On The Map',
    headline: ['Anywhere you point,', "we've got a plan."],
    /** The phrase rendered in RoamMyWay blue. */
    highlight: "we've got a plan.",
    body: 'The Eiffel Tower, the Taj Mahal, Sydney Harbour — wherever you land on this globe, RoamMyWay already knows the route to get you there.',
  },
  /** Scroll-scrubbed showcase between Why-Choose and Community. */
  journey: {
    eyebrow: 'See It Before You Book It',
    headline: ['One scroll,', 'one full itinerary.'],
    /** The phrase rendered in RoamMyWay blue. */
    highlight: 'one full itinerary.',
    body: 'Drag through a real RoamMyWay plan from golden-hour arrival to last call — this is what a finished itinerary actually looks like.',
  },
  /** Closing banner, mounted last, just before the footer. */
  closingCta: {
    eyebrow: 'Powered By RoamMyWay AI',
    headline: ['Name the place.', "We'll map the rest."],
    /** The phrase rendered in RoamMyWay blue. */
    highlight: "We'll map the rest.",
    body: "Tell our AI companion where you want to go and it handles the route, the timing and the stops — all that's left is packing.",
    cta: { label: 'Plan My Trip', href: '#how-it-works' },
  },
}

export const navigation = [
  { label: 'How it works', href: '#how-it-works' },
  { label: 'Why Choose RoamMyWay', href: '#why-roammyway' },
  { label: 'Community Plans', href: '#community' },
]

// Was '#' in the standalone prototype ("Placeholder until auth exists") --
// now ported into the real romaya-web app, which already has real auth at
// this route (see src/App.jsx).
export const signInHref = '/auth/signin'

export const footerLinks = {
  company: [
    { label: 'About', href: '#' },
    { label: 'Contact', href: '#' },
  ],
  legal: [
    { label: 'Privacy', href: '#' },
    { label: 'Terms', href: '#' },
  ],
}
